export default {
	reference: {
		perPage: 200,
		resettable: true,
		sort: { field: "name", order: "ASC" },
		emptyText: "ra.action.all",
	},
};
